module.exports = __webpack_public_path__ + "img/img1.26f30399.gif";